/**
 * Cart page: when checkout button's HTML `form="cart-form"` association fails (seen with
 * `<cart-items-component>` / some browsers), submit the real cart form with this button as
 * the submitter so `name="checkout"` is sent. No-op when `button.form` already points at
 * `#cart-form`.
 */
(function () {
  document.addEventListener(
    'click',
    function (e) {
      const target = e.target;
      if (!(target instanceof Element)) return;
      const btn = target.closest('#checkout');
      if (!btn || !(btn instanceof HTMLButtonElement)) return;
      if (btn.name !== 'checkout') return;
      if (btn.hasAttribute('disabled')) return;
      const form = document.getElementById('cart-form');
      if (!(form instanceof HTMLFormElement)) return;
      if (btn.form === form) return;
      e.preventDefault();
      form.requestSubmit(btn);
    },
    true
  );
})();
